<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
          <div class="col-md-12"> <strong>Configuracion</strong>
              <br/>
              <div class="custom-control custom-checkbox">
                Tipo Motor<select class="form-control" v-model="configuration.TIPO_ACTIVIDAD">
                  <option value="0">(0) Reconocimiento de monedas-billetes. Identificar el valor de una moneda o billete</option>
                  <option value="1">(1) Operaciones con monedas-billetes. Obtener el valor de un grupo de monedas y/o billetes</option>
                  <option value="2">(2) Operaciones con monedas-billetes. Comparar valores</option>
                  <option value="3">(3) Operaciones con monedas-billetes. Comparar valores.  Cuánto más</option>
                  <option value="4">(4) Operaciones con monedas-billetes. Cambiar</option>
                  <option value="5">(5) Operaciones con monedas-billetes. Cambio de expresión</option>
                  <option value="6">(6) Pagar usando monedas y billetes. Con o sin criterio económico</option>
                </select>
              </div>
              <div class="custom-control custom-checkbox">
                Tipo Actividad<select class="form-control" v-model="configuration.SUBTIPO_ACTIVIDAD">
                  <!-- TIPO_ACTIVIDAD 0 -->
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) ===0" value="0">Identificar el valor de una moneda o billete [monendero_a]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 0" value="1">Identificar la moneda o billete con su valor [monendero_a]</option>
                  <!-- TIPO_ACTIVIDAD 1 -->
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 1" value="0">Contar dinero y escribir el total [monendero_a]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 1" value="1">Elegir las monedas y billetes necesarios para alcanzar una cantidad [cantidad_a]</option>
                  <!-- TIPO_ACTIVIDAD 2 -->
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="0">Discriminar la moneda o billete que vale más. [monedero_a,monedero_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="1">Discriminar la moneda o billete que vale menos [monedero_a,monedero_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="2">Discriminar si son equivalentes.(monedas-cifra) [monendero_a,cantidad_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="3">Discriminar si son equivalentes.(cifra-monedas) [cantidad_a,monedero_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="4">Discriminar si son equivalentes.(cifra-cifra) [cantidad_a,cantidad_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="5">Discriminar si son equivalentes.(monedas-monedas) [monedero_a,monedero_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="6">Discriminar el grupo de monedas y billetes que vale más.(monedas-cifra) [monendero_a,cantidad_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="7">Discriminar el grupo de monedas y billetes que vale más.(cifra-monedas) [cantidad_a,monedero_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="8">Discriminar el grupo de monedas y billetes que vale más.(cifra-cifra) [cantidad_a,cantidad_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="9">Discriminar el grupo de monedas y billetes que vale más.(monedas-monedas) [monedero_a,monedero_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="10">Discriminar el grupo de monedas y billetes que vale menos.(monedas-cifra) [monendero_a,cantidad_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="11">Discriminar el grupo de monedas y billetes que vale menos.(cifra-monedas) [cantidad_a,monedero_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="12">Discriminar el grupo de monedas y billetes que vale menos.(cifra-cifra) [cantidad_a,cantidad_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 2" value="13">Discriminar el grupo de monedas y billetes que vale menos.(monedas-monedas) [monedero_a,monedero_b]</option>
                  <!-- TIPO_ACTIVIDAD 3 -->
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 3" value="0">Identificar que monedas y/o billetes falta para que los grupos sean equivalentes.(monedas-monedas) [cantidad_a,cantidad_b]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 3" value="1">Identificar que cantidad falta para que los grupos sean equivalentes.(cifra-cifra) [cantidad_a,cantidad_b]</option>
                  <!-- TIPO_ACTIVIDAD 4 -->
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 4" value="0">Cambiar moneda y/o billete. [monendero_a]</option>
                  <!-- TIPO_ACTIVIDAD 5 -->
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 5" value="0">Expresa en euros [monendero_a]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 5" value="1">Expresa en euros y céntimos [monendero_a]</option>
                  <!-- TIPO_ACTIVIDAD 6 -->
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 6" value="0">Elegir las monedas y billetes necesarios para pagar una cantidad dada [cantidad_a,imagen]</option>
                  <option v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 6" value="1">Elegir las monedas y billetes necesarios para pagar y comprobar el cambio [cantidad_a,imagen]</option>
                </select>
              </div>
          </div>
          <div class="col-md-6 mt-4"> <strong>Conf. Izquierda</strong>
              <div class="custom-control custom-checkbox">
                Agrupación de elementos<select class="form-control" v-model="configuration.REPRESENTACION_MONEDERO">
                  <option value="0">unicos</option>
                  <option value="1">agrupados</option>
                </select>
              </div>
              <div class="custom-control custom-checkbox">
                Criterio monedero<select class="form-control" v-model="configuration.CRITERIO_MONEDERO">
                  <option value="0">no económico</option>
                  <option value="1">económico</option>
                </select>
              </div>
              <br />
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.ARABIGO"
                id="ARABIGO">
                <label class="custom-control-label" for="ARABIGO">Arábigo</label>
              </div>
              <div class="custom-control custom-checkbox">
                Expresión arabiga<select class="form-control" v-model="configuration.EXPRESION_ARABIGO">
                  <option value="0">decimal</option>
                  <option value="1">natural</option>
                </select>
              </div>
              <div class="custom-control custom-checkbox">
                Abreviación arabiga<select class="form-control" v-model="configuration.ABREVIADA_ARABIGO">
                  <option value="0">abreviada</option>
                  <option value="1">entera</option>
                </select>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ESCRITO"
                id="VERBAL_ESCRITO">
                <label class="custom-control-label" for="VERBAL_ESCRITO">Verbal escrito</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ORAL"
                id="VERBAL_ORAL">
                <label class="custom-control-label" for="VERBAL_ORAL">Verbal oral</label>
              </div>
          </div>
          <div class="col-md-6 mt-4"> <strong>Conf. Derecha</strong>
            <div class="custom-control custom-checkbox">
              Agrupación de elementos<select class="form-control" v-model="configuration.REPRESENTACION_MONEDERO_RESPUESTA">
                <option value="0">unicos</option>
                <option value="1">agrupados</option>
              </select>
            </div>
            <div class="custom-control custom-checkbox">
              Criterio monedero<select class="form-control" v-model="configuration.REPRESENTACION_MONEDERO_RESPUESTA">
                <option value="0">no económico</option>
                <option value="1">económico</option>
              </select>
            </div>
            <br>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input"
              v-model="configuration.ARABIGO_RESPUESTA"
              id="ARABIGO_RESPUESTA">
              <label class="custom-control-label" for="ARABIGO_RESPUESTA">Arábigo</label>
            </div>
            <div class="custom-control custom-checkbox">
              Expresión arabiga<select class="form-control" v-model="configuration.EXPRESION_ARABIGO_RESPUESTA">
                <option value="0">decimal</option>
                <option value="1">natural</option>
              </select>
            </div>
            <div class="custom-control custom-checkbox">
              Abreviación arabiga<select class="form-control" v-model="configuration.ABREVIADA_ARABIGO_RESPUESTA">
                <option value="0">abreviada</option>
                <option value="1">entera</option>
              </select>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input"
              v-model="configuration.VERBAL_ESCRITO_RESPUESTA"
              id="VERBAL_ESCRITO_RESPUESTA">
              <label class="custom-control-label" for="VERBAL_ESCRITO_RESPUESTA">Verbal escrito</label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input"
              v-model="configuration.VERBAL_ORAL_RESPUESTA"
              id="VERBAL_ORAL_RESPUESTA">
              <label class="custom-control-label" for="VERBAL_ORAL_RESPUESTA">Verbal oral</label>
            </div>
          </div>
          <div class="col-md-12 mt-4">
              <strong>Monedero respuesta</strong>
              <br />
              <div class="row mt-3">
                <div class="col-md-12 d-flex small text-center">
                  <div>
                    1ct
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[0]"></b-form-input>
                  </div>
                  <div>
                    2ct
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[1]"></b-form-input>
                  </div>
                  <div>
                    5ct
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[2]"></b-form-input>
                  </div>
                  <div>
                    10ct
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[3]"></b-form-input>
                  </div>
                  <div>
                    20ct
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[4]"></b-form-input>
                  </div>
                  <div>
                    50ct
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[5]"></b-form-input>
                  </div>
                  <div>
                    1€
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[6]"></b-form-input>
                  </div>
                  <div>
                    2€
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[7]"></b-form-input>
                  </div>
                  <div>
                    5€
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[8]"></b-form-input>
                  </div>
                  <div>
                    10€
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[9]"></b-form-input>
                  </div>
                  <div>
                    20€
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[10]"></b-form-input>
                  </div>
                  <div>
                    50€
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[11]"></b-form-input>
                  </div>
                  <div>
                    100€
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[12]"></b-form-input>
                  </div>
                  <div>
                    200€
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[13]"></b-form-input>
                  </div>
                  <div>
                    500€
                    <b-form-input type="number" v-model="configuration.MONEDAS_RESPUESTA[14]"></b-form-input>
                  </div>
                </div>
                <div class="col-md-6 mt-3">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input"
                    v-model="configuration.CAMBIO_RESPUESTA"
                    id="CAMBIO_RESPUESTA">
                    <label class="custom-control-label" for="CAMBIO_RESPUESTA">Pedir cambio</label>
                  </div>
                  <div v-if="configuration.CAMBIO_RESPUESTA">
                    Desviación cambio<select class="form-control" v-model="configuration.DESVIACION_RESPUESTA">
                      <option value="0">minima </option>
                      <option value="1">media</option>
                      <option value="2">maxima</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 mt-3">
                  <div class="custom-control custom-checkbox">
                    Elementos respuesta<select class="form-control" v-model="configuration.ELEMENTOS_MONEDERO_RESPUESTA">
                      <option value="0">monedas</option>
                      <option value="1">billetes</option>
                      <option value="1">ambos</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 mt-3">
                  <div class="custom-control custom-checkbox">
                    Cantidad elementos<select class="form-control" v-model="configuration.CANTIDAD_ELEMENTOS_MONEDERO_RESPUESTA">
                      <option value="0">infinito </option>
                      <option value="1">finitos</option>
                    </select>
                  </div>
                </div>
              </div>
          </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br />
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row  class="justify-content-md-center">
                <b-col sm="10" style="text-align:center"><h6>Monedero A</h6></b-col>
                <b-col sm="2" style="text-align:center"><h6>Cantidad A</h6></b-col>
            </b-row>
            <b-row class="justify-content-md-center">
              <b-col sm="10" class="d-flex small text-center">
                <div>
                  1ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[0]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  2ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[1]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  5ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[2]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  10ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[3]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  20ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[4]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  50ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[5]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  1€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[6]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  2€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[7]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  5€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[8]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  10€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[9]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  20€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[10]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  50€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[11]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  100€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[12]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  200€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[13]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
                <div>
                  500€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_A[14]" @change="calculateMonederoA(index)"></b-form-input>
                </div>
              </b-col>
              <b-col sm="2" class="small text-center">
                Total
                <b-form-input type="number" disabled
                    v-model="arrayEleOperation[index].CANTIDAD_A">
                    </b-form-input>
              </b-col>
            </b-row>
            <br />
            <b-row  class="justify-content-md-center">
                <b-col sm="10" style="text-align:center"><h6>Monedero B</h6></b-col>
                <b-col sm="2" style="text-align:center"><h6>Cantidad B</h6></b-col>
            </b-row>
            <b-row class="justify-content-md-center">
              <b-col sm="10" class="d-flex small text-center">
                <div>
                  1ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[0]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  2ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[1]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  5ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[2]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  10ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[3]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  20ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[4]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  50ct
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[5]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  1€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[6]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  2€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[7]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  5€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[8]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  10€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[9]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  20€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[10]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  50€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[11]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  100€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[12]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  200€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[13]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
                <div>
                  500€
                  <b-form-input type="number" v-model="arrayEleOperation[index].MONEDAS_B[14]" @change="calculateMonederoB(index)"></b-form-input>
                </div>
              </b-col>
              <b-col sm="2" class="small text-center">
                Total
                <b-form-input type="number" disabled
                    v-model="arrayEleOperation[index].CANTIDAD_B">
                    </b-form-input>
              </b-col>
            </b-row>
            <br>
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col md="12" v-if="parseInt(configuration.TIPO_ACTIVIDAD)===6">
                <label>Imagen compra</label>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <input type="text" v-model="arrayEleOperation[index].NOMBRE_IMAGEN"
                    disabled class="form-control">
                    <searchimages class="pl-2" v-bind:idModal="'mdlSearchImage_'+index"
                      v-on:selected="onSelectedImage($event, index)">
                    </searchimages>
                  </div>
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <div class="row">
                  <div class="col-lg-6">
                    <div class="cardtheme groupimage p-4">
                      <a href="javascript:void(0);" class="file" v-show="arrayEleOperation[index].IMAGENES_ID !== null && arrayEleOperation[index].IMAGENES_ID !== 0">
                        <div class="image">
                            <img :src="getTranslation(arrayEleOperation[index].FICHERO)" alt="img" class="img-fluid">
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
            </b-row>
          <hr />
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="preSaveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';
import searchimages from '../../images/SearchImages.vue';
import translationMixin from '../../../../mixins/translation';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin, translationMixin],
  components: {
    exercises,
    searchimages,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla TIEMPO_CONF
      configuration: {
        ID: -1,
        TIPO_ACTIVIDAD: 1,
        SUBTIPO_ACTIVIDAD: 0,
        REPRESENTACION_MONEDERO: 0,
        CRITERIO_MONEDERO: 0,
        ARABIGO: false,
        EXPRESION_ARABIGO: 0,
        ABREVIADA_ARABIGO: 0,
        VERBAL_ESCRITO: false,
        VERBAL_ORAL: false,
        REPRESENTACION_MONEDERO_RESPUESTA: 0,
        CRITERIO_MONEDERO_RESPUESTA: 0,
        ELEMENTOS_MONEDERO_RESPUESTA: 0,
        CANTIDAD_ELEMENTOS_MONEDERO_RESPUESTA: 0,
        MONEDAS_RESPUESTA: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        CANTIDADES_MONEDERO_RESPUESTA: '0,0,0,0,0,0,0,0,0,0,0,0,0,0,0',
        CAMBIO_RESPUESTA: false,
        DESVIACION_RESPUESTA: 0,
        ARABIGO_RESPUESTA: false,
        EXPRESION_ARABIGO_RESPUESTA: 0,
        ABREVIADA_ARABIGO_RESPUESTA: 0,
        VERBAL_ESCRITO_RESPUESTA: false,
        VERBAL_ORAL_RESPUESTA: false,
        EJERCICIOS_ID: -1, //
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        MONEDAS_A: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        MONEDERO_A: '0,0,0,0,0,0,0,0,0,0,0,0,0,0,0',
        CANTIDAD_A: null,
        MONEDAS_B: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        MONEDERO_B: '0,0,0,0,0,0,0,0,0,0,0,0,0,0,0',
        CANTIDAD_B: null,
        IMAGENES_ID: null,
        NOMBRE_IMAGEN: null,
        FICHERO: [],
      });
    },
    getValueMoneda(id) {
      const arrayValues = [0.01, 0.02, 0.05, 0.10, 0.20, 0.50, 1, 2, 5, 10, 20, 50, 100, 200, 500];
      return arrayValues[id];
    },
    calculateMonederoA(index) {
      let total = 0;
      for (let i = 0; i < this.arrayEleOperation[index].MONEDAS_A.length; i += 1) {
        const value = this.getValueMoneda(i);
        const quantity = this.arrayEleOperation[index].MONEDAS_A[i];

        total += (value * quantity);
      }
      this.arrayEleOperation[index].CANTIDAD_A = total;
    },
    calculateMonederoB(index) {
      let total = 0;
      for (let i = 0; i < this.arrayEleOperation[index].MONEDAS_B.length; i += 1) {
        const value = this.getValueMoneda(i);
        const quantity = this.arrayEleOperation[index].MONEDAS_B[i];

        total += (value * quantity);
      }
      this.arrayEleOperation[index].CANTIDAD_B = total;
    },
    /**
    * @method saveStorage
    * @description Guarda los datos del formulario
    */
    preSaveStorage() {
      this.configuration.CANTIDADES_MONEDERO_RESPUESTA = this.configuration.MONEDAS_RESPUESTA.join(',');

      this.saveStorage();
    },
    async getMotorData(id) {
      this.loading = true;
      try {
        const response = await this.axios.get('money/getmoney', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        this.configuration.MONEDAS_RESPUESTA = this.configuration.CANTIDADES_MONEDERO_RESPUESTA.split(',');
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            MONEDAS_A: element.MONEDERO_A !== null ? element.MONEDERO_A.split(',') : '0,0,0,0,0,0,0,0,0,0,0,0,0,0,0'.split(','),
            MONEDERO_A: element.MONEDERO_A,
            CANTIDAD_A: element.CANTIDAD_A,
            MONEDAS_B: element.MONEDERO_B !== null ? element.MONEDERO_B.split(',') : '0,0,0,0,0,0,0,0,0,0,0,0,0,0,0'.split(','),
            MONEDERO_B: element.MONEDERO_B,
            CANTIDAD_B: element.CANTIDAD_B,
            IMAGENES_ID: element.IMAGENES_ID,
            NOMBRE_IMAGEN: element.NOMBRE_IMAGEN,
            FICHERO: element.FICHERO,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
    /**
    * @method onSelectedImage
    * @description Al buscar una imagen
    */
    onSelectedImage(itemSelected, idOperation) {
      this.arrayEleOperation[idOperation].IMAGENES_ID = itemSelected.ID;
      this.arrayEleOperation[idOperation].NOMBRE_IMAGEN = itemSelected.NOMBRE;
      this.arrayEleOperation[idOperation].FICHERO = itemSelected.FICHERO;
      this.$root.$emit('bv::hide::modal', `mdlSearchImage_${idOperation}`);
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
